var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"echart",staticStyle:{"width":"inherit","height":"inherit"}})}
var staticRenderFns = []

export { render, staticRenderFns }